import React from 'react';

import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface CampaignWebhookDeleteDialogProps {
  open: boolean;
  name?: string;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const CampaignWebhookDeleteDialog: React.FC<CampaignWebhookDeleteDialogProps> = ({
  open,
  name,
  isLoading,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={isLoading ? undefined : onClose} fullWidth maxWidth="xs">
      <DialogTitle>{t('campaignPage.webhooks.deleteTitle')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('campaignPage.webhooks.deleteDescription', {
            name: name || t('campaignPage.webhooks.unnamed'),
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          {t('common.cancel')}
        </Button>
        <Button color="error" variant="contained" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? <CircularProgress size={20} color="inherit" /> : t('common.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CampaignWebhookDeleteDialog;
